var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function fetchCurrentChannelInfo(auth) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const url = new URL("https://api.twitch.tv/helix/channels");
        url.searchParams.set("broadcaster_id", auth.channelId);
        const response = yield fetch(url, {
            headers: {
                "client-id": auth.clientId,
                Authorization: `Extension ${auth.helixToken}`,
            },
        });
        const data = (yield response.json()); // TODO: validate schema?
        if ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.length)
            return data.data[0];
        return null;
    });
}
